import { FontColorEnum, FontWeightEnum, Typography } from '@acceso/design-system';
import clsx from 'clsx';

type TimeFieldProps = {
  label: string;
  time: string;
  classname?: string;
};

export function TimeFieldWithDelivery({ label, time, classname }: TimeFieldProps) {
  return (
    <div className={clsx('flex gap-1', classname)}>
      <Typography color={FontColorEnum.Medium20} weight={FontWeightEnum.Semibold}>
        {`${label}:`}
      </Typography>

      <Typography color={FontColorEnum.Medium20}>{time}</Typography>
    </div>
  );
}
